<template>
  <div>
    <div class="up-input-group">
      <div>
        <up-numberinput
          v-model="color_grid.styles.width"
          size="sm"
          label="Width"
          labelIcon="mdi mdi-alpha-w-box-outline"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          v-model="color_grid.styles.height"
          size="sm"
          label="Height"
          labelIcon="mdi mdi-alpha-h-box-outline"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          v-model="color_grid.num_columns"
          size="sm"
          label="Number of Columns"
          labelIcon="mdi mdi-dots-horizontal"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          v-model="color_grid.num_rows"
          size="sm"
          label="Number of Rows"
          labelIcon="mdi mdi-dots-vertical"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          v-model="color_grid.answer"
          size="sm"
          label="Answer"
          labelIcon="mdi mdi-alpha-a-box-outline"
        ></up-numberinput>
      </div>
      <div>
        <up-switch
          v-model="color_grid.is_answer_rectangle"
          label="Is Answer Rectangle"
          labelIcon="mdi mdi-alpha-d-box-outline"
        ></up-switch>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-12">
        <style-editor
          title="box"
          show_border_color
          show_bg_color
          v-model="color_grid.box_styles"
        ></style-editor>
      </div>
    </div>
    <show-color-grid :color_grid="color_grid"></show-color-grid>
  </div>
</template>

<script>
import { defaultColorGridValue } from "./utils";
import ShowColorGrid from "./ShowColorGrid.vue";
import StyleEditor from "@/components/Common/StyleEditor/StyleEditor";

import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";
import UpSwitch from "@/components/UI/Inputs/UpSwitch";
export default {
  name: "set-color-grid",
  props: {
    value: {
      type: Object,
    },
  },
  components: {
    ShowColorGrid,
    StyleEditor,
    UpNumberinput,
    UpSwitch  
  },
  data() {
    return {
      color_grid: this.value ? this.value : defaultColorGridValue(),
    };
  },
  watch: {
    color_grid: {
      handler: function(new_val) {
        this.$emit("input", new_val);
      },
      deep: true,
    },
    value: {
      handler: function(new_val) {
        this.color_grid = new_val;
      },
      deep: true,
    },
  },
};
</script>
<style scoped></style>
